import React from 'react';
import Slider from 'react-slick';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import 'slick-carousel/slick/slick.css'; // Import Slick carousel styles
import 'slick-carousel/slick/slick-theme.css'; // Import Slick carousel theme styles

const Brand = () => {
 const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,             // 🔁 Enable autoplay
  autoplaySpeed: 1000,        // ⏱️ 2 seconds per slide
  pauseOnHover: true,         // 🖱️ Pause when mouse hovers
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};


  return (
    <div className="container  " >
      <div className="col-lg-6 offset-lg-3">
        <h2 className="text-center Layout-Title">TOP BRANDS</h2>
        <p className="text-center mb-5">
          From its medieval origins to the digital era, learn everything there is
          to know about the ubiquitous lorem ipsum passage.
        </p>
      </div>

      <div className="row no-gutters mt-3">
        <div className="col-md-12 div-anim my-auto">
          <div className="brand-carousel-wrapper" style={{ width: "60%", alignContent: "center", margin: "auto" }}>

          <Slider {...settings}>
            <div>
              <div className="prod-div text-center">
                <div className="prod-img">
                  <img src="images/brand1.png" alt="Brand 1" className="img-fluid" />
                </div>
              </div>
            </div>
            <div>
              <div className="prod-div text-center">
                <div className="prod-img">
                  <img src="images/brand2.png" alt="Brand 2" className="img-fluid" />
                </div>
              </div>
            </div>
            <div>
              <div className="prod-div text-center">
                <div className="prod-img">
                  <img src="images/brand3.png" alt="Brand 3" className="img-fluid" />
                </div>
              </div>
            </div>
            <div>
              <div className="prod-div text-center">
                <div className="prod-img">
                  <img src="images/brand5.png" alt="Brand 5" className="img-fluid" />
                </div>
              </div>
            </div>
            <div>
              <div className="prod-div text-center">
                <div className="prod-img">
                  <img src="images/brand6.png" alt="Brand 6" className="img-fluid" />
                </div>
              </div>
            </div>
            <div>
              <div className="prod-div text-center">
                <div className="prod-img">
                  <img src="images/brand4.png" alt="Brand 4" className="img-fluid" />
                </div>
              </div>
            </div>
            <div>
              <div className="prod-div text-center">
                <div className="prod-img">
                  <img src="images/brand4.png" alt="Brand 4" className="img-fluid" />
                </div>
              </div>
            </div>
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Brand;
